import { IFormViewForm } from 'components/FormView';

const PickSlipLineDetailsForm: IFormViewForm = {
  id: 'PickSlipLineDetailsForm',
  layout: {
    rows: 1,
    columns: 2
  },
  fields: [
    {
      id: 1,
      position: {
        row: 1,
        col: 1
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        label: '',
        fullWidth: true
      },
      children: [
        {
          id: '0',
          type: 'TEXT_FIELD',
          props: {
            label: 'Product',
            name: 'ProductIdDisplay',
            placeholder: '',
            size: 'medium',
            disabled: true,
            inputProps: {
              maxLength: 40
            }
          }
        },
        {
          id: '1',
          type: 'TEXT_FIELD',
          props: {
            label: '',
            name: 'Description',
            placeholder: '',
            size: 'large',
          }
        },
        {
          id: '2',
          type: 'EXTENDED_TEXT_FIELD',
          props: {
            label: 'Quantity',
            name: 'Quantity',
            placeholder: '',
            size: 'small',
            required: false,
            decimalSeparator: true,
            alignment: 'right',
          }
        },
        {
          id: '3',
          type: 'EXTENDED_TEXT_FIELD',
          props: {
            label: 'Price',
            name: 'Price',
            placeholder: '',
            size: 'medium',
            required: false,
            decimalSeparator: true,
            alignment: 'right',
          }
        },
        {
          id: '6',
          type: 'EXTENDED_DISPLAY_FIELD',
          visible: true,
          props: {
            label: 'Discount',
            name: 'Discount',
            size: 'small',
            type: 'number',
            decimalSeparator: true,
            adornment: '%',
          }
        },
        // {
        //   id: '7',
        //   type: 'CALCULATOR_FIELD',
        //   props: {
        //     label: 'Restocking charge',
        //     name: 'RestockingCharge',
        //     size: 'medium',
        //     decimalSeparator: true,
        //     alignment: 'right',
        //   }
        // },
        {
          id: '7',
          type: 'RESTOCKING_CALCULATOR',
          props: {
            label: 'Restocking charge',
            name: 'RestockingCharge',
            size: 'medium',
            alignment: 'right',
          }
        },
        {
          id: '2',
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Credit reason',
            name: 'Reason',
            placeholder: '',
            size: 'small',
            required: false,
            lookupName: 'CustomerCreditReason'
          }
        },
      ]
    },
    {
      id: 1,
      position: {
        row: 1,
        col: 2
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        fullWidth: true
      },
      children: [
        {
          id: 6,
          type: 'TEXT_AREA',
          props: {
            label: 'Comment',
            name: 'Comment',
            size: 'large',
            style: {
              height: '465px',
            }
          }
        }
      ]
    },
  ]
};

export default PickSlipLineDetailsForm;
